import React, { useContext, useState, useEffect } from 'react'
import StoreContext from '~/context/StoreContext'
import DesignContext from '~/context/DesignContext'
import ConditionalWrapper from '~/components/ConditionalWrapper'

import { Canvas, CanvasLayer, Preview, Frame } from './styles'
import { Type, Background, Text, Logo } from './assets'

export default ({ config }) => {
  const {
    store: { selectedProductOptions },
  } = useContext(StoreContext)

  const {
    character,
    color,
    size,
    style,
    scale,
    layout,
    personalisedText,
    personalisedText2,
    inverted,
    frame,
  } = !config ? selectedProductOptions : config

  const [typePaths, setTypePaths] = useState(null)

  useEffect(() => {
    async function fetchData() {
      const response = await fetch(`/${style}.json`)
      const data = await response.json()

      setTypePaths(data)
    }
    fetchData()
  }, [style])

  const { styles, constants } = useContext(DesignContext)

  const { colors, text, logo } = styles[style].colors.find(
    ({ value }) => value === color
  )

  const [textColor, backgroundColor] = colors

  const sizes = size.replace('cm', '').split('x')

  const layoutSize = constants.layouts[size][layout]
  const textSize = constants.text[size][layout]
  const offsetSize = constants.offset[size][layout]
  const fontSize = constants.fontSize[size]
  const logoObj = constants.logo[size]
  const letterSpacing = constants.letterSpacing[size]
  const textOffset = constants.textOffset[size]

  return (
    <Preview
      size={sizes}
      id="preview"
      framed={frame != 'Uden ramme'}
      frameWidth={constants.frames[size]}
      frameColor={constants.frames.colors[frame]}
    >
      <Canvas>
        <ConditionalWrapper
          condition={layout === 'polaroid' || layout === 'framed'}
          wrapper={children => (
            <Frame
              layout={layout}
              sizes={layoutSize}
              offset={offsetSize}
              originalSizes={sizes}
            >
              {children}
            </Frame>
          )}
        >
          <CanvasLayer
            style={{
              height: '110%',
            }}
          >
            <Background
              sizes={layoutSize}
              backgroundColor={
                inverted === 'true' ? textColor : backgroundColor
              }
            />
          </CanvasLayer>
          <CanvasLayer
            style={{
              transformOrigin: '50% 50%',
              transform: `translateY(-50%) scale(${parseInt(scale) / 100})`,
              top: layout === 'polaroid' ? '50%' : '50%',
            }}
          >
            {typePaths && (
              <Type
                characterPath={typePaths[character]}
                textColor={inverted === 'true' ? backgroundColor : textColor}
              />
            )}
          </CanvasLayer>
        </ConditionalWrapper>
        <CanvasLayer
          style={{
            transform: 'none',
            bottom: 0,
            top: 'auto',
          }}
        >
          <Text
            viewBox={textSize}
            fontSize={fontSize}
            letterSpacing={letterSpacing}
            textOffset={textOffset}
            color={
              layout === 'polaroid'
                ? 'black'
                : inverted === 'true'
                ? text['invert']
                : text['standard']
            }
            originalSizes={sizes}
          >
            {`${personalisedText}\n${personalisedText2}`}
          </Text>
        </CanvasLayer>

        <Logo
          fill={
            layout === 'polaroid'
              ? '#000'
              : inverted === 'true'
              ? logo['invert']
              : logo['standard']
          }
          style={{
            position: 'absolute',
            right: `${(100 * logoObj.offset[layout]) / sizes[0]}%`,
            bottom: `${(100 * logoObj.offset[layout]) / sizes[1]}%`,
            width: `${(100 * logoObj.size) / sizes[0]}%`,
          }}
        />
      </Canvas>
    </Preview>
  )
}
